import { __rest } from 'tslib';
import { t } from '../../i18n.es.js';
import React from 'react';
import { LazyImage } from '@teko/ui';
import emptyImage from './search-no-result.es.js';
import { Flex } from '../Flex/Flex.es.js';
import { Text } from '../Text/Text.es.js';

const EmptyState = (_a) => {
    var { text } = _a, props = __rest(_a, ["text"]);
    return (React.createElement(Flex, Object.assign({}, props, { flexDirection: "column", justifyContent: "center", alignItems: "center" }),
        React.createElement(LazyImage, { height: 128, width: 128, src: emptyImage }),
        React.createElement(Text, { fontSize: 12, color: "#848788", marginTop: "24px", paddingX: "2rem" }, text || t('Không tìm thấy dữ liệu'))));
};

export { EmptyState };
